import { usePickSaveContext, RecordContextProvider, Record, useCreateController, useSaveModifiers, useRefresh, useResourceContext, useVersion, useUpdate, CRUD_UPDATE } from "ra-core";
import { CreateProps } from "ra-core/esm/controller/details/useCreateController";
import { EditProps } from "ra-core/esm/controller/details/useEditController";
import { FC, useCallback } from "react";
import SaveContextProvider from "./SaveContextProvider";

const CreateOrEdit: FC<CreateProps | EditProps> = ({ children, ...props }) => {
  const record = (props as any).record;

  const createCtrls = useCreateController(props)
  
  const editCtrls = useOverridedEditController({ mutationMode: 'pessimistic', ...props});

  return (
    <SaveContextProvider value={usePickSaveContext(record !== null && record !== undefined ? editCtrls : createCtrls)}>
      <RecordContextProvider<Partial<Record>>
        value={record}
      >
        {children}
      </RecordContextProvider>
    </SaveContextProvider>
  )
}

export default CreateOrEdit;

function useOverridedEditController(props: {}) {
  const {
    basePath,
    hasCreate,
    hasEdit,
    hasList,
    hasShow,
    id,
    successMessage,
    // @deprecated use mutationMode: undoable instead
    undoable = true,
    onSuccess,
    onFailure,
    mutationMode = undoable ? 'undoable' : undefined,
    transform,
  } = props as EditProps;
  const resource = useResourceContext(props);
  const refresh = useRefresh();
  const version = useVersion();

  const {
    onSuccessRef, setOnSuccess, onFailureRef, setOnFailure, transformRef, setTransform,
  } = useSaveModifiers({ onSuccess, onFailure, transform });

  const record:Record = (props as any).record;
  const [update, { loading: saving }] = useUpdate(
    record ? resource : 'noop',
    record?.id,
    {},
    record
  );

  const save = useCallback(
    (
      data: Partial<Record>,
      redirectTo = 'list',
      {
        onSuccess: onSuccessFromSave, onFailure: onFailureFromSave, transform: transformFromSave,
      } = {}
    ) => Promise.resolve(
        transformFromSave    ? transformFromSave(data)
      : transformRef.current ? transformRef.current(data) 
      : data
    ).then(data => update(
      { payload: { data } },
      {
        action: CRUD_UPDATE,
        onSuccess: 
            onSuccessFromSave    ? onSuccessFromSave
          : onSuccessRef.current ? onSuccessRef.current
          : () => { },
        onFailure: 
            onFailureFromSave    ? onFailureFromSave
          : onFailureRef.current ? onFailureRef.current
          : error => { },
        mutationMode,
      }
    )),
    [
      transformRef,
      update,
      onSuccessRef,
      onFailureRef,
      successMessage,
      basePath,
      refresh,
      mutationMode,
    ]
  );
  
  return {
    loading: false,
    loaded: true,
    saving,
    hasCreate,
    hasEdit,
    hasList,
    hasShow,
    onSuccessRef,
    onFailureRef,
    transformRef,
    save,
    setOnSuccess,
    setOnFailure,
    setTransform,
    resource,
    basePath,
    record,
    redirect: 'list',
    version,
  };
}

